import getNetworkImageData from 'lib/api/NetworkImageData';

export const LOAD_NETWORK_IMAGE_DATA = 'LOAD_NETWORK_IMAGE_DATA';

export function loadNetworkImageData() {
    return (dispatch) => getNetworkImageData()
        .then((networkImageData) => {
            dispatch({
                type: LOAD_NETWORK_IMAGE_DATA,
                payload: networkImageData
            });
        });
}



// WEBPACK FOOTER //
// ./app/common/NetworkLogo/actions.js